import $ from 'jquery'

export default class BaseReportStore {
    constructor() {
        this.reportData = null
        this.reportParams = null
        this.groupingData = null
        this.generatedPDF = null
        this.fileName = "file.pdf"
        this.printParametersForGenerate = null
        this.printParametersForSave = {
            paperOrientation: "PORTRAIT",
            paperSize: "A4",
            showHeaderOnEachPage: false,
            showLogoInHeader: true
        }
    }

    getReportData() {
        return this.reportData
    }

    setReportData(reportData, groupingData) {
        this.reportData = reportData
        this.groupingData = groupingData
        $(this).trigger("reportDataChange")
    }

    getReportParams() {
        return this.reportParams
    }

    setReportParams(reportParams) {
        this.reportParams = reportParams
        $(this).trigger("reportParamsChange")
    }

    getUsers() {
        return this.groupingData.USER
    }

    getUserGroups() {
        return this.groupingData.USER_GROUP
    }

    getTimeZoneGroups() {
        return this.groupingData.TIME_ZONE_GROUP
    }

    getUser(id) {
        return this.groupingData.USER[id]
    }

    getUserGroup(id) {
        return this.groupingData.USER_GROUP[id]
    }

    getTimeZoneGroup(id) {
        return this.groupingData.TIME_ZONE_GROUP[id]
    }

    getDateInfo(id) {
        return this.groupingData.DATE[id]
    }

    getMonth(id) {
        return this.groupingData.MONTH[id]
    }

    getWeek(id) {
        return this.groupingData.WEEK[id]
    }

    getGeneratedPDF() {
        return this.generatedPDF
    }

    setGeneratedPDF(generatedPDF) {
        this.generatedPDF = generatedPDF
        $(this).trigger("generatedPDFChange")
    }

    getPDFFileName() {
        return this.fileName
    }

    setPDFFileName(fileName) {
        this.fileName = fileName
    }

    getPrintParametersForSave() {
        return this.printParametersForSave
    }

    setPrintParametersForSave(printParametersForSave) {
        this.printParametersForSave = printParametersForSave
        $(this).trigger("printParametersForSaveChange")
    }

    getPrintParametersForGenerate() {
        return this.printParametersForGenerate
    }

    setPrintParametersForGenerate(printParametersForSave) {
        this.printParametersForGenerate = printParametersForSave
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/BaseReportStore.js